import angular from 'angular';

import styles from './styles.less';

import routes from './routes';

import template from './template.html'
import controller from './controller'

export default angular.module('app.main.panel.module.doorLocks', [])
	.config(routes)
	.component('doorLocks', {
		template: template,
		controller: controller,
		controllerAs: 'ctrl',
	})
	.name;


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/doorLocks.component/index.js
 **/